/*
 * @Descripttion: 
 * @version: 
 * @Author: chenlongad
 * @Date: 2021-01-13 15:30:38
 * @LastEditors: chenlongad
 * @LastEditTime: 2021-03-17 10:05:16
 */
const clientId = 'tplusclient';
const clientSecret = 'pwjd5q';
const xlsky = 'NkNDNEQ0RTUtMTg3Mi00Q0IyLUFBOEYtQzc5ODg0NUFEMEVD';
const xlssrt = 'amFxNXl6';
// const proxyServer = 'http://cloudproxy01.chanapp.chanjet.com';
const authKey = 'AuthKey';
// const channelKey = 'ChannelKey';
const storeKey = 'StoreKey';
// const ciaHostArray = ['http://cia.chanapp.chanjet.com'];
// const ciaHost = 'http://cia.chanapp.chanjet.com';
// const tplusHostArray = ['http://webapp.tplus.chanjet.com'];
// const devProxyHost = 'http://localhost:9998';
// const prodProxyHost = 'http://localhost:9998';
const tplusWebAppApiHost = 'http://webapp.tplus.chanjet.com/pos/api/v1/';//prod
const tplusWebAppApiHost_test = 'http://test-webapp.tplus.chanjet.com/pos/api/v1/'; //test

export {
    clientId,
    clientSecret,
    xlsky,
    xlssrt,
    // proxyServer,
    authKey,
    // channelKey,
    storeKey,
    // ciaHostArray,
    // tplusHostArray,
    // devProxyHost,
    // prodProxyHost,
    // ciaHost,
    tplusWebAppApiHost,
    tplusWebAppApiHost_test
}
